import { useRole } from '../../common/hooks/useRole';
import { Box } from '../../common/ui/Box';
import { OfferModel } from '../model/OfferModel';

import { getOfferChatAccessState } from './getOfferChatAccessState';
import { OfferChatInfo } from './OfferChatInfo';
import { OfferChatInput } from './OfferChatInput';
import { OfferChatMessages } from './OfferChatMessages';

interface OfferChatProps {
    offer: OfferModel;
}

export const OfferChat = ({ offer }: OfferChatProps) => {
    const role = useRole();
    const { showForwardedOfferInfoText, showInfoText, isMessagingAllowed } = getOfferChatAccessState(offer, role);

    return (
        <Box display="flex" flexDirection="column" backgroundColor="white" height="100%">
            <OfferChatMessages offer={offer} />
            <OfferChatInfo showForwardedOfferInfoText={showForwardedOfferInfoText} showInfoText={showInfoText} />
            {isMessagingAllowed ? <OfferChatInput offerId={offer.id} /> : null}
        </Box>
    );
};
